module.exports = __webpack_public_path__ + "static/media/ViewIcon.3c6f93cc.svg";